function showError(root, message) {
  const err = root.querySelector('[data-ca-callback-error]');
  const actions = root.querySelector('[data-ca-callback-actions]');
  if (err) {
    err.hidden = false;
    err.textContent = message;
  }
  if (actions) actions.hidden = false;
}

function withPreviewParams(path) {
  const current = new URL(window.location.href);
  const target = new URL(path, window.location.origin);
  const keysToPreserve = ['preview_theme_id', '_fd', 'pb'];

  keysToPreserve.forEach((key) => {
    const value = current.searchParams.get(key);
    if (value && !target.searchParams.has(key)) {
      target.searchParams.set(key, value);
    }
  });

  return `${target.pathname}${target.search}`;
}

window.addEventListener('DOMContentLoaded', async () => {
  const root = document.querySelector('[data-ca-callback]');
  if (!root) return;

  try {
    const storefrontDomain = root.dataset.storefrontDomain;
    const clientId = root.dataset.clientId;
    const redirectUri = root.dataset.redirectUri;
    await window.CustomerAccount.handleCustomerAccountCallback({ storefrontDomain, clientId, redirectUri });
    window.location.assign(withPreviewParams(root.dataset.postLoginPath || '/pages/my-account'));
  } catch (e) {
    showError(root, e?.message || 'Sign-in failed.');
  }
});

